import { useRef, useState, useEffect } from 'react';
import styles from './styles.module.scss';
import { Icons } from 'pages/Quotes/Icons';

type ArchivedMenuPropsType = {
  unarchiveHandler: Function;
};

const ArchivedMenu = (props: ArchivedMenuPropsType) => {
  const { unarchiveHandler } = props;
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const menuRef = useRef<any>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      let targetId = '';
      if (event.target) {
        targetId = (event.target as any).id;
      }

      if (targetId === 'quote-row-unarchive-menu' || targetId === 'quote-row-unarchive-menu-icon')
        return;

      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      className={styles.archivedMenu}
      onClick={(e) => {
        setShowMenu((prev) => !prev);
        e.preventDefault();
        e.stopPropagation();
      }}
      id="quote-row-unarchive-menu"
    >
      <Icons
        variant={Icons.HAMBURGER}
        className={styles.hbIcon}
        testid="quote-row-unarchive-menu-icon"
      />
      {showMenu && (
        <div className={styles.menu} ref={menuRef}>
          <div className={styles.item} onClick={(e) => unarchiveHandler(e)}>
            <span className={styles.icon}>
              <Icons variant={Icons.UNARCHIVE} containerized={false} />
            </span>
            <div className={styles.label}>Unarchive</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ArchivedMenu;
